export const SUPPLY_TYPE_FILTER_QUERY_PARAM = "supplyType" as const;
